module.exports = __webpack_public_path__ + "images/unit-icons/10x10-storage.svg";